import Vue from 'vue'
import {
  ConfigProvider,
  Button,
  Layout,
  Dropdown,
  Menu,
  Icon,
  Modal,
  Pagination,
  FormModel,
  Input,
  Checkbox,
  Breadcrumb,
  Table,
  InputNumber,
  Radio,
  DatePicker,
  Progress,
  Popover,
  Tooltip,
  Upload,
  Skeleton,
  Spin,
  Empty,
  Select
} from 'ant-design-vue'
import MpIcon from '@/components/icon'

const AntComponents = [
  ConfigProvider,
  Button,
  Layout,
  Dropdown,
  Menu,
  Icon,
  Modal,
  Pagination,
  FormModel,
  Input,
  Checkbox,
  Breadcrumb,
  Table,
  InputNumber,
  Radio,
  DatePicker,
  Progress,
  Popover,
  Tooltip,
  Upload,
  Skeleton,
  Spin,
  Empty,
  Select
]

AntComponents.forEach(c => {
  Vue.use(c)
})

Vue.component('mp-icon', MpIcon)
